<template>
  <div class="pagescreen">
    <div class="menbros">
      <div class="relative flex justify-center items-center h-[49px] lh-[49px] text-center px-[14px]">
        <!-- 背景层 -->
        <div class="absolute inset-0 bg-[#000000] opacity-[0.3]"></div>
        <!-- 内容层 -->
        <img :src="getAssetsFile('activity/lefts (3).png')" alt="" class="absolute left-[14px] z-10 w-[6px] h-[10px]"
          @click="back()">
        <div class="relative z-10 text-[16px] color-[#FFFFFF] font-bold">{{ t('membros.title') }}</div>
      </div>
      <div class="flex w-full  justify-center items-center  absolute top-[198px]">
        <div class="annius">
          <div class="titles1">{{ t('membros.eventEndTime') }}</div>
          <div class="titles2">{{ t('membros.permanent') }}</div>
        </div>
      </div>
    </div>
    <div class="mx-[25px] mt-[70px]">
      <div>
        <div class="flex items-center">
          <img :src="getAssetsFile('activity/lefts (2).png')" alt="" class="w-[22px] h-[22px]">
          <div class="color-[#8690B7] text-[13px] ml-[6px]">{{ t('membros.collectionTime') }}</div>
        </div>
        <div class="bg-[#2A3046] rounded-[8px] p-[16px] color-[#BDE8FE] text-[20px] mt-[17px] text-center">
          {{ t('membros.collectionDate') }}
        </div>
      </div>

      <div class="mt-[23px]">
        <div class="flex items-center">
          <img :src="getAssetsFile('activity/lefts (1).png')" alt="" class="w-[21px] h-[27px]">
          <div class="color-[#8690B7] text-[13px] ml-[6px]">{{ t('membros.maxPossibleReward') }}</div>
        </div>
        <div class="bg-[#2A3046] rounded-[8px] p-[16px] color-[#BDE8FE] text-[32px] mt-[17px] text-center font-bold">
          <span class="text-[14px] color-[#495274]">{{ VITE_symbol }}</span>
          8.888,00
        </div>
      </div>
      <div class="mt-[27px]">
        <div class="footertitle">{{ t('membros.activityRules') }}</div>
        <div class="mt-[16px] color-[#8690B7] text-[16px] pb-[30px]">
          <p>{{ t('membros.eventDetails') }}:</p>
          <p>{{ t('membros.rule1') }}</p>
          <p>{{ t('membros.rule2') }}</p>
          <p>{{ t('membros.rule3') }}</p>
          <p>{{ t('membros.rule4') }}</p>
          <p>{{ t('membros.rule5') }}</p>
        </div>
      </div>

    </div>
    <div class="footerfilxed">
      <div class="footerbutton">{{ t('membros.receive') }}</div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n'
const VITE_symbol = import.meta.env.VITE_SYMBOL
const { t } = useI18n()
const router = useRouter();
const back = () => {
  router.back();
}
</script>
<style lang="scss" scoped>
.pagescreen {
  background: #000 !important;
  min-height: 100vh !important;
  /* 使用负边距覆盖底部的padding区域 */
  margin-bottom: calc(-50px - env(safe-area-inset-bottom));
  padding-bottom: calc(50px + env(safe-area-inset-bottom));
}

:deep(.app-wrapper) {
  background: #004D37 !important;
}

.menbros {
  background: getPath('activity/appreciationFollow_bg.png') no-repeat center center;
  background-size: 100% 100%;
  width: 100%;
  height: 231px;
  position: relative;
}

.annius {
  background: getPath('activity/lefts (4).png') no-repeat center center;
  background-size: 100% 100%;
  width: 70%;
  height: 69px;

}

.titles1 {
  font-size: 15px;
  color: #FFFFFF;
  background: linear-gradient(180deg, #D198FA 0%, #8744BE 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;
  line-height: 23px;
  margin-top: 10px;
}

.titles2 {
  font-weight: bold;
  font-size: 19px;
  color: #FFFFFF;
  background: linear-gradient(180deg, #DABAFF 0%, #A8BBFD 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;
  line-height: 23px;
}

.footertitle {
  font-size: 15px;
  color: #FFFFFF;
  background: linear-gradient(180deg, #B4DAF4 0%, #7990AD 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.footerfilxed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 70px;
  background: #121629;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.footerbutton {
  width: 80%;
  height: 46px;
  line-height: 46px;
  background: linear-gradient(180deg, #52387D, #462E77);
  border-radius: 4px;
  text-align: center;
  color: #888993;
  font-size: 15px;

}
</style>
<route lang="json5">
    {
      name: 'Membros',
      meta: {
        title: 'Membros',
        i18n: 'menus.Membros'
      },
    }
    </route>
